import React from 'react';
import { FiInfo, FiUsers, FiTarget, FiGift } from 'react-icons/fi';

const CompanyEmployeeHelp = () => {
  return (
    <div className="company-help">
      <div className="help-header">
        <FiInfo className="help-icon" />
        <div>
          <h2>Employee Tier System</h2>
          <p>Understand how benefit tiers work for your employees</p>
        </div>
      </div>

      <div className="help-content">
        <div className="tier-explanation">
          <h3>How Benefit Tiers Work</h3>
          <p>
            The Benetica platform uses a 3-tier system to provide different levels of benefits 
            to your employees. When vendors create offers, they can target specific tiers, 
            ensuring the right benefits reach the right employees.
          </p>
        </div>

        <div className="tiers-grid">
          <div className="tier-card tier-1">
            <div className="tier-header">
              <FiUsers className="tier-icon" />
              <h4>Tier 1 - All Employees</h4>
            </div>
            <div className="tier-details">
              <ul>
                <li>General company offers and discounts</li>
                <li>Standard wellness programs</li>
                <li>Basic retail and dining benefits</li>
                <li>Employee assistance programs</li>
                <li>Standard gym memberships</li>
              </ul>
              <div className="tier-note">
                <strong>Includes:</strong> General staff, entry-level positions, hourly workers
              </div>
            </div>
          </div>

          <div className="tier-card tier-2">
            <div className="tier-header">
              <FiTarget className="tier-icon" />
              <h4>Tier 2 - Managers</h4>
            </div>
            <div className="tier-details">
              <ul>
                <li>All Tier 1 benefits included</li>
                <li>Management training programs</li>
                <li>Enhanced healthcare options</li>
                <li>Business travel benefits</li>
                <li>Professional development perks</li>
                <li>Premium dining experiences</li>
              </ul>
              <div className="tier-note">
                <strong>Includes:</strong> Team leads, department managers, supervisors
              </div>
            </div>
          </div>

          <div className="tier-card tier-3">
            <div className="tier-header">
              <FiGift className="tier-icon" />
              <h4>Tier 3 - Executives</h4>
            </div>
            <div className="tier-details">
              <ul>
                <li>All Tier 1 & 2 benefits included</li>
                <li>Executive coaching programs</li>
                <li>Premium lifestyle services</li>
                <li>VIP vendor partnerships</li>
                <li>Luxury travel and dining</li>
                <li>Exclusive executive events</li>
              </ul>
              <div className="tier-note">
                <strong>Includes:</strong> Senior leadership, C-level executives, directors
              </div>
            </div>
          </div>
        </div>

        <div className="how-it-works">
          <h3>How Employees See Offers</h3>
          <div className="flow-steps">
            <div className="flow-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>Vendor Creates Offer</h4>
                <p>Vendors create offers and select which tiers can access them</p>
              </div>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>Employee Logs In</h4>
                <p>Employee logs into the app using their phone number</p>
              </div>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>Filtered Offers</h4>
                <p>They only see offers that match their tier level and company</p>
              </div>
            </div>
          </div>
        </div>

        <div className="tier-assignment-tips">
          <h3>Role-Based Tier Assignment</h3>
          <div className="tips-grid">
            <div className="tip">
              <h4>👥 Organization Structure</h4>
              <p>Assign tiers based on organizational hierarchy and reporting structure</p>
            </div>
            <div className="tip">
              <h4>💼 Job Responsibilities</h4>
              <p>Consider decision-making authority, budget responsibility, and team size</p>
            </div>
            <div className="tip">
              <h4>🎯 Strategic Value</h4>
              <p>Higher tiers reflect greater strategic impact and business responsibility</p>
            </div>
            <div className="tip">
              <h4>📊 Clear Criteria</h4>
              <p>Establish clear criteria for each tier to ensure fair and consistent assignment</p>
            </div>
          </div>
        </div>

          <div className="vendor-benefits">
          <h3>What This Means for Your Company</h3>
          <ul>
            <li><strong>Role-Appropriate Benefits:</strong> Vendors create offers that match organizational levels</li>
            <li><strong>Budget Alignment:</strong> Higher-value offers align with compensation levels</li>
            <li><strong>Fair Distribution:</strong> Benefits match responsibility and contribution levels</li>
            <li><strong>Vendor Engagement:</strong> Partners can create relevant offers for each audience</li>
            <li><strong>Clear Structure:</strong> Transparent tier system based on organizational roles</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CompanyEmployeeHelp;